/**
 * <SearchList />
 *
 * TODO: doc needed
 *
 * @parent Modal
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames';
import SearchBar from 'components/UI/SearchBar'
import {isEqual, filter, find } from 'lodash';
import Loading from 'components/UI/Loading'
import NameCircle from 'components/UI/NameCircle'

import './SearchList.scss';

const SELECTED_FIRST = 'SELECTED_FIRST';

const NOT_SELECTED_FIRST = 'NOT_SELECTED_FIRST';

const DEFAULT_SORTABLE = false;

const SEARCH_TIMEOUT = 250;

const MIN_SEARCH_VALUE_LENGTH = 2;


const DefaultSelectItem = ({item, getItemLabel, selected, onClickSelect}) => {
  return (
    <div className='select-item' >
      <div>
        { typeof(getItemLabel) == 'function' ? <h5>{getItemLabel(item)}</h5> : item.label }
      </div>
      <div className='select-button'>
        { selected && <span className='btn-link currently-selected' onClick={onClickSelect}>{__('Selected', 'SelectItemModal')}</span>}
        { !selected && <span className='btn-link' onClick={onClickSelect}>{__('Select', 'SelectItemModal')}</span>}
      </div>
    </div>
   );
}

class SearchList extends React.Component {
  static propTypes = {
    //
    // Name of item
    //
    itemName: PropTypes.string,

    //
    // hide searchbar
    //
    hideSearchbar: PropTypes.bool,

    //
    // Placeholder appears in searchbar
    //
    searchPlaceholder: PropTypes.string,

    //
    // a function that returns a label, used to in search and also basic item label
    //
    getItemLabel: PropTypes.func,

    //
    // An array of items. If you were to use fetchItems, it is basically an init value
    //
    itemList: PropTypes.array,

    //
    // An array of items marked as selected
    //
    selected: PropTypes.array,

    //
    // enable/disable sort selected. Default is null (true)
    //
    sortSelected: PropTypes.bool,

    //
    // If objiects in selected are not the same object as
    // in the list. We use selectFilter() to determine which
    // data is selected.
    //
    selectFilter: PropTypes.func,

    //
    // When true you can sort order the items per 'selected'
    //
    isSelectedSortable: PropTypes.bool,

    //
    // AJAX call function. Should fire a callback with an array
    //
    fetchItems: PropTypes.func,

    //
    // fires when an item is selected by clicking selected/unselect
    //
    onSelect: PropTypes.func.isRequired,

    //
    // allow delect. Default is null/false
    //
    allowDeselect: PropTypes.bool,

    //
    // mixin
    //
    mixin: PropTypes.func,

    //
    // backendSearch: Search via a backend call
    //
    backendSearch: PropTypes.bool,


  }

  constructor(props) {
    super(props);

    this._loadItemesOntoState = this._loadItemesOntoState.bind(this);
    this._onSearchSelected = this._onSearchSelected.bind(this);
    this._getSelectList = this._getSelectList.bind(this);
    this._onClickSelect = this._onClickSelect.bind(this);
    this._toggleOrderItem = this._toggleOrderItem.bind(this);
    this._toggleArray = this._toggleArray.bind(this);
    this._sortSelected = this._sortSelected.bind(this);
    this._onSearch = this._onSearch.bind(this);
    this.onListScroll = this.onListScroll.bind(this);
    this.state = {
      selected: props.selected || [],
      optionsForSearch: [],
      selectedOption: undefined,
      itemListOrder: SELECTED_FIRST,
      itemList: props.itemList,
      currentPageNumber: 0,
      searchKeyword: undefined,
    }

    this.state.itemList = this._sortSelected(props.itemList) || [];
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.selected) {
      this.setState({
        selected: nextProps.selected,
      });
    }

    if (!isEqual(nextProps.itemList, this.props.itemList)) {
      this.setState({
        itemList: this._sortSelected(nextProps.itemList),
      });
    }
  }

  componentWillMount() {
    this._loadItemesOntoState();
  }

  _onClickSelect(item) {
    let { onSelect } = this.props;
    return (e)=>{
      let { selected } = this.state;

      let newSelected = this._toggleArray(selected, item);

      this.setState({
        selected: newSelected,
      }, ()=>{
        onSelect(newSelected);
      });
    }
  }

  _toggleArray(selected, item) {

    const {
      allowDeselect,
      selectFilter,
    } = this.props;

    let filtered = [];

    // STEP 1. filter it out the item
    filtered = filter(selected, (alreadySelected, idx)=>{
      if (typeof selectFilter == 'function') {
        return selectFilter(item, alreadySelected, selected) === false;
      } else {
        return isEqual(alreadySelected, item) === false;
      }
    });

    // STEP 2. if the length is different, which means the item has been removed
    // we return the removed array
    if (filtered.length != selected.length) {
      // if the modal allow deselecting, we return the deselected array
      // otherwise we return the array as it was
      if (allowDeselect) {
        return filtered;
      } else {
        return selected;
      }

    } else {
      // If the length of both arrays were the same, it means the item was already in
      // the array, so we simply push the item into the array and return it.
      filtered.push(item);
      return filtered;
    }


  }

  _loadItemesOntoState(fetchOpts = {}) {
    const {
      refreshItemList,
    } = fetchOpts;

    let {
      fetchItems,
      getItemLabel,
    } = this.props;

    let {
      maxPageNumber = -1,
      currentPageNumber,
      searchKeyword,
    } = this.state;

    if (typeof fetchItems !== 'function') {
      return;
    }

    // to prevent infinite loading 
    if (currentPageNumber > 0 && maxPageNumber == -1) {
      return;
    }
    // ---

    if (maxPageNumber > 0 && currentPageNumber >= maxPageNumber) {
      return;
    }
    
    let newPageNumber = currentPageNumber + 1;

    //
    // If fetchItem() exists, we start fetching it remotely,
    // and will indicate that we're fetching.
    //
    this.setState({
      fetching: true,
      currentPageNumber: newPageNumber,
    });

    fetchItems((itemList, fetchResult = {})=>{

      const {
        maxPageNumber,
      } = fetchResult;

      this.savedItemList = itemList;

      let newItemList;

      if (refreshItemList) {
        newItemList = [ ...itemList ];
        
        if (this.selectListRef) {
          this.selectListRef.scrollTop = 0;
        }
      } else {
        newItemList = [
          ...this.state.itemList,
          ...itemList,
        ];
      }
    
      let optionsForSearch = newItemList.map((item, idx)=>{
        let label;
        if (typeof getItemLabel == 'function') {
          label = getItemLabel(item);
        } else {
          label = item.label;
        }

        return {
          id: idx,
          label,
          value: item,
        }
      });

      this.setState({
        maxPageNumber,
        itemList: this._sortSelected(newItemList),
        optionsForSearch,
        fetching: false,
      });
    }, {
      // Search query: START
      currentPageNumber: newPageNumber,
      searchKeyword, 
      // Search query: END
    });
  }

  _onSearchSelected(selected) {

    // STEP 1. if selected is empty, which means the select field is clear out.
    // Then, we update with the itemList saved in this.
    if (selected === null) {
      this.setState({
        selectedOption: undefined,
        itemList: this.savedItemList,
      });
      return;
    }

    // STEP 2. If selected is indeed an list item object, then we recreate
    // this.state.itemList by filtering out current list.
    let {
      value: item
    } = selected

    let newItemList = this.savedItemList.filter((thisCls)=>{
      return isEqual(thisCls, item);
    });

    this.setState({
      selectedOption: selected,
      itemList: newItemList,
    });
  }

  _toggleOrderItem() {
    const {
      itemListOrder,
      itemList,
    } = this.state;

    this.setState({
      itemListOrder: itemListOrder === SELECTED_FIRST ? NOT_SELECTED_FIRST : SELECTED_FIRST,
    }, ()=>{
      this.setState({
        itemList: this._sortSelected(itemList)
      })
    });
  }

  _sortSelected(itemList) {
    if (!itemList) {
      return;
    }

    let {
      sortSelected,
    } = this.props;

    if (sortSelected === false) {
      return itemList;
    }

    const {
      selected,
      itemListOrder,
    } = this.state;

    let inSelected = [];
    let notInSelected = [];

    itemList.map((item)=>{
      if (this._arrayHas(selected, item)) {
        inSelected.push(item);
      } else {
        notInSelected.push(item);
      }
    });

    if (itemListOrder == SELECTED_FIRST) {
      return inSelected.concat(notInSelected)
    } else {
      return notInSelected.concat(inSelected)
    }
  }

  _onSearch(e) {
    
    const {
      backendSearch,
    } = this.props;
    
    const { value = '' } = e.target;

    if (!backendSearch) {
      return;
    }

    let searchKeyword = value;

    if (value.length < MIN_SEARCH_VALUE_LENGTH) {
      searchKeyword = '';
    }

    if (this.debouncedSearchTimeout) {
      clearTimeout(this.debouncedSearchTimeout);
    }
    
    this.debouncedSearchTimeout = setTimeout(()=>{
      this.setState({
        searchKeyword,
        currentPageNumber: 0,
      }, ()=>{
        this._loadItemesOntoState({
          refreshItemList: true,
        });
      });
    }, SEARCH_TIMEOUT);

  }

  onListScroll(e) {
    const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    if (bottom) { 
      this._loadItemesOntoState();
    } 
  }

  render() {

    let {
      selectedOption,
      optionsForSearch,
      itemListOrder,
      fetching,
    } = this.state;

    let {
      itemName,
      hideSearchbar,
      backendSearch = false,
      searchPlaceholder,
      allowDeselect,
      isSelectedSortable = DEFAULT_SORTABLE,
      selected,
      getItemLabel,
      showName = false,
    } = this.props;

    return (
      <div className={classnames('classtop-search-list', {'allow-deselect': allowDeselect, 'select-none': typeof selectedOption == 'undefined'})}>
        { fetching && <Loading /> }
        { hideSearchbar !== true &&
          <div className='searchbar-wrapper'>
            { backendSearch !== true &&
              <SearchBar is class='form-control'
                selectedOption={selectedOption}
                options={optionsForSearch}
                onOptionSelected={this._onSearchSelected}
                placeholder={searchPlaceholder} /> }
            { backendSearch == true &&
              <input 
                type='text' 
                classname='form-control'
                onChange={this._onSearch}
                placeholder={searchPlaceholder}
              />
            }
            </div>
        }
        <div className='label-section'>
          { itemName && <label>{itemName}</label> }
          { isSelectedSortable && <div className='sort-btn btn-link pull-right' onClick={this._toggleOrderItem}>
            { /* itemListOrder == SELECTED_FIRST  && <i className='fa fa-sort-amount-desc'></i> */ }
            { /* itemListOrder == NOT_SELECTED_FIRST && <i className='fa fa-sort-amount-asc'></i> */ }
          </div> }
          {showName === true && <div className='display-name'>
            { selected.map((item) => {
              return(
                <NameCircle fullName={typeof(getItemLabel) == 'function' ? getItemLabel(item) : item.label} showFullName={false} />
              )
            })}
          </div>}
        </div>
        <div className='select-list' onScroll={this.onListScroll} ref={(r)=>{ this.selectListRef = r; }}>
          {this._getSelectList()}
        </div>
      </div>
    );
  }

    _getSelectList() {
      let {
        itemList,
        itemListOrder,
        selected,
      } = this.state;

      let {
        components = {},
        SelectItem,
        getItemLabel,
        mixin,
      } = this.props;

      const ListItem = SelectItem || components.SelectItem || DefaultSelectItem;

      return itemList.map((item, idx)=>{
        let isSelected = this._arrayHas(selected, item);

        return (
          <ListItem
            selected={isSelected}
            getItemLabel={getItemLabel}
            item={item}
            key={idx}
            onClickSelect = {this._onClickSelect(item)}
            mixin={mixin}
          />
        );
      });
    }

    _arrayHas(hash, needle) {
      let {
        selectFilter,
      } = this.props;

      return (
        typeof find(hash, (o)=>{
          if (typeof selectFilter == 'function') {
            return selectFilter(needle, o, hash);
          } else {
            return isEqual(o, needle);
          }
        }) !== 'undefined'
      );
    }
}

export default SearchList;



// WEBPACK FOOTER //
// ./src/components/UI/SearchList/index.js